
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { MenuItems } from "./audioHeaderComponenta"
import { AudioHeaderNavMutam } from "./audioHeaderMutamMenu"
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces"
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage"


interface SiteAudioHeaderMobileProps {
    navItems: MenuItems[]
    bgColor?: string
    termsLink?: string
    contactUsLink?: string
    accessibilityLink?: string
    logoUrl?: string
    darkLogoUrl?: string
    logoLink?: string
    logoLinkTarget?: LinkTargetProperties
}
interface SiteAudioHeaderMobileState{
hasScrolled:boolean
}
export class SiteAudioHeaderMobileComponenta extends React.Component<SiteAudioHeaderMobileProps, SiteAudioHeaderMobileState> {
      public static siteScriptName = "SiteAudioHeaderMobileComponenta"
    constructor(props) {
        super(props)
        this.state = {
          hasScrolled: false
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    private handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const shouldHaveScrolledClass = scrollTop > 50; // Adjust threshold as needed
        
        if (shouldHaveScrolledClass !== this.state.hasScrolled) {
            this.setState({ hasScrolled: shouldHaveScrolledClass });
        }
    }
    private openNativeShare = async () => {
        const current_url = window.location.href;
        const shareData = { url: current_url, title: document.title }
        try {
            // @ts-ignore
            await navigator.share(shareData)
        } catch (err) {
            console.log("error with sharing function", err);
            }
        
    }

    render() {
        const {  navItems, bgColor, termsLink, contactUsLink, accessibilityLink, logoLink, logoLinkTarget , darkLogoUrl,logoUrl } = this.props
        const { hasScrolled } = this.state


        return (
                <div className={`AudioHeaderComponenta ${hasScrolled ? "bodyScrolled" : ""}`} style={{background:hasScrolled ? "rgba(35, 30, 30, 0.90)": bgColor}}> 
                   <a href="javascript:history.back()" className="goBack" title="back" aria-label="חזור אחורה"></a>
                    <HyperLinkBuilder href={logoLink} linkTarget={logoLinkTarget} className="mainLogo" >
                                         <SiteSimpleImage src={hasScrolled ? darkLogoUrl: logoUrl } />
                                     </HyperLinkBuilder>
                <div className="mobileShareBtn" onClick={this.openNativeShare}></div>     
                    <AudioHeaderNavMutam 
                    logoUrl={logoUrl}
                    navItems={navItems}  termsLink={termsLink} contactUsLink={contactUsLink} accessibilityLink={accessibilityLink} />
                </div>
        )
    }
}